/**
 * Flags temporales de producto.
 */
/** Botón / acción de envío por correo (resultados, éxito, ENVIAR OFERTA). */
export const SHOW_EMAIL_SHARE = true;

/** Botón de WhatsApp en resultados. */
export const SHOW_WHATSAPP_SHARE = true;
